// https://github.com/vuejs/vue-cli/issues/2754#issuecomment-522321907
import Vue from 'vue/dist/vue.min.js';
import HistoryCompanySlider from '../../components/HistoryCompany/HistoryCompanySlider.vue';
import initApplicationGlobal from '../Global/Global';

export default function initHistoryCompany(eventHub) {
  initApplicationGlobal(eventHub);

  new Vue(HistoryCompanySlider);
}
